import {ButtonGroup} from "@/components/ui/button-group.tsx";
import {Button} from "@/components/ui/button.tsx";
import {useState} from "react";
import {MinusIcon, PlusIcon} from "lucide-react";
import {Input} from "@/components/ui/input.tsx";


export default function DiceRollsView({setResult}: { setResult: (result: number) => void }) {

    const [diceRolls, setDiceRolls] = useState<number[]>([])
    const [dice, setDice] = useState<number[]>([])
    const [added, setAdded] = useState<number>(0)

    const addRoll = (die: number) => {
        const roll = Math.floor(Math.random() * (die) + 1)
        const newRolls = [...diceRolls, roll];
        setDiceRolls(newRolls)
        setDice([...dice, die])
        setResult(newRolls.reduce((count, current) => count + current, added))
    }

    const updateAdded = (newAdded: number) => {
        setAdded(newAdded)
        setResult(diceRolls.reduce((count, current) => count + current, newAdded))
    }

    const reset = () => {
        setDiceRolls([])
        setDice([])
        setAdded(0)
        setResult(0)
    }

    const sum = diceRolls.reduce((count, current) => count + current, added)

    return (
        <div className="flex flex-col gap-4">
            <div className="flex items-center gap-4">
                <ButtonGroup>
                    <Button type="button" size="sm" variant="outline"
                            onClick={() => addRoll(4)}>🎲4</Button>
                    <Button type="button" size="sm" variant="outline"
                            onClick={() => addRoll(6)}>🎲6</Button>
                    <Button type="button" size="sm" variant="outline"
                            onClick={() => addRoll(8)}>🎲8</Button>
                    <Button type="button" size="sm" variant="outline"
                            onClick={() => addRoll(10)}>🎲10</Button>
                    <Button type="button" size="sm" variant="outline"
                            onClick={() => addRoll(12)}>🎲12</Button>
                </ButtonGroup>

                <ButtonGroup>
                    <Button type="button" aria-label="Würfelbonus verringern" variant="outline" size="sm" onClick={() => updateAdded(Math.max(added - 1, 0))}>
                        <MinusIcon/>
                    </Button>
                    <Input aria-label="Würfelbonus" type="number" min={0} step={1} required value={added} size={1}
                           className="h-7"
                           onChange={(e) => updateAdded(Number(e.target.value))}/>
                    <Button type="button" aria-label="Würfelbonus erhöhen" variant="outline" size="sm" onClick={() => updateAdded(added + 1)}>
                        <PlusIcon/>
                    </Button>
                </ButtonGroup>

                {(diceRolls.length > 0 || added !== 0) &&
                    <Button type="button" size="sm" variant="destructive"
                            onClick={() => reset()}>Reset</Button>
                }

            </div>
            {(diceRolls.length > 0 || added !== 0) &&
                <div className="rounded-md border bg-surface px-3 py-1">
                    {diceRolls
                        .map((roll, index) => `${roll} (🎲${dice[index]})`)
                        .join(" + ")} {(diceRolls.length > 0 && added !== 0) && '+'} {added !== 0 && added} <strong>= {sum}</strong>
                </div>
            }
        </div>
    )
}
